//
//
//
//
//
//
import Vue from 'vue';
import vueJsonTreeView from 'vue-json-tree-view';
import packJson from '../../../../../package.json';
Vue.use(vueJsonTreeView);
export default {
  data: function data() {
    return {
      options: {
        maxDepth: 10,
        rootObjectKey: 'package.json',
        modifiable: false
      },
      packJson: packJson
    };
  }
};